/** 站方會回播「自己送出的訊息」的類型。UT 是空的（兩種都沒有回播）。 */
export const SITE_ECHOES_SELF = {
    ek21: ['say', 'pm'],
    ut: [],
};
/**
 * 這次送出的訊息，之後會不會被站方回播？
 *
 * `service` 缺席時回 `true`：舊呼叫端（與不知道站別的測試）維持原本的樂觀行為，
 * 不要因為少傳一個欄位就突然把所有訊息標成「無回執」。
 */
export function expectsEcho(service, kind) {
    if (!service)
        return true;
    return (SITE_ECHOES_SELF[service] ?? SITE_ECHOES_SELF['ek21'] ?? []).includes(kind);
}
/**
 * 送達狀態標籤（白話：不出現函數名、端點、狀態列舉名稱）。
 * 加上受理時間：使用者要的是「什麼時候被站方收下的」，不是一句「無回執」。
 */
export function acceptedLabel(ts) {
    return `已受理 ${clockLabel(ts)}`;
}
/** 舊名保留（測試與外部呼叫端仍在用）：不帶時間的版本。 */
export const NO_RECEIPT_LABEL = '已受理（平台無回執）';
/**
 * 滑過標籤時看到的解釋；也是「重整後為什麼這則不見了」的答案。
 *
 * 2026-10-26 改寫：舊版只說「沒有辦法證明」，等於把站方限制丟回給使用者。
 * 現在同一句裡要交代三件事——站方不提供回執、站方已受理（時間）、**下一步能做什麼**。
 */
export function acceptedHint(ts) {
    return (`這個平台不提供送達回執；這句話已由站方受理（${clockLabel(ts)}）。` +
        '「用第二個帳號確認」會叫同房的另一個身分去讀訊息列表，看到就是真的送到了。');
}
/** 舊名保留：不帶時間的說明文字。 */
export const NO_RECEIPT_HINT = '這個平台不提供送達回執。這句話已由站方受理，但單憑這條連線看不到對方；'
    + '「用第二個帳號確認」會叫同房的另一個身分去讀訊息列表。重整之後這一則就不會留下。';
/** `HH:MM`（24 小時制）；只用在標籤上，不進任何判定。 */
export function clockLabel(ts) {
    const date = new Date(ts);
    if (!Number.isFinite(date.getTime()))
        return '--:--';
    const hh = String(date.getHours()).padStart(2, '0');
    const mm = String(date.getMinutes()).padStart(2, '0');
    return `${hh}:${mm}`;
}
/** 「傳送中」的標籤文字（只有真正在等站方回應時才出現）。 */
export const SENDING_LABEL = '傳送中…';
//# sourceMappingURL=delivery.js.map